;(function templateService() {
    function templateService() {
        /**
         * local template service
         * @private
         */
        var _this = this

        /**
         * Generate a new HTML Object
         *
         * @method getFilledTemplate
         * @param templateIdentifier HTML identifier
         * @param valueJSON
         * @return {Object}
         */
        this.getFilledTemplate = function (templateIdentifier, valueJSON) {
            if($(templateIdentifier).length < 1) {
                return '';
            }

            var template = $(templateIdentifier).html()

            for (var marker in valueJSON) {
                // build a global regexp
                var regex = new RegExp(marker, 'g')

                template = template.replace(regex, function (matched) {
                    return valueJSON[matched]
                })
            }
            return $(template)
        }
    }

    // define the global scope
    if (!window.Creaton) {
        window.Creaton = {}
    }
    window.Creaton.templateService = templateService
})()
